import React, { useEffect, useState } from 'react'
import cus from '../images/cus.png'
import axios from 'axios';
import './BusinessEnq.css'
import { Alert } from 'react-bootstrap';
import apiClient from '../api/apiClient';



export default function BusinessEnq() {

  // State to manage the selected value
  const [selectedOption, setSelectedOption] = useState('');
  const [serviceOptions, setServiceOptions] = useState([]);
  const [submissionStatus, setSubmissionStatus] = useState(null); // Track submission status

  // useEffect(() => {
  //   // Fetch service names and sub-service names from backend
  //   axios.get(`${BASE_URL}/serviceent/list`)
  //     .then(response => {
  //       setServiceOptions(response.data);
  //     })
  //     .catch(error => {
  //       console.error('Error fetching service options:', error);
  //     });
  // }, []);


  useEffect(() => {
    const fetchPoData = async () => {
      try {
        const response = await apiClient.get(`/serviceent/list`);
        if (response.status === 200) {
          setServiceOptions(response.data);
        } else {
          // Handle unexpected status codes
          console.error('Unexpected status code:', response.status);
        }
      } catch (error) {
        // Handle network errors or other exceptions
        console.error('Error fetching service options:', error);
      }
    };

    fetchPoData();
  }, []);


  // Function to handle changes in the selected value
  const handleChange = (event) => {
    console.log('My name is handleChange')
    console.log('Selected value:', event.target.value);
    setSelectedOption(event.target.value);
    console.log('Selected value:', event.target.value);
  };

  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const requestData = {
      fName: formData.get('fName'),
      lName: formData.get('lName'),
      bEmail: formData.get('bEmail'),
      selectedService: {
        serId: parseInt(selectedOption)
      }, // Assuming selectedOption is a string representing the selected service
      contactNumber: formData.get('contactNumber'),
      address: formData.get('address'),
      message: formData.get('message'),
    };
  console.log('Request data',requestData)
  console.log('Selected option',selectedOption)
    try {
      const response = await apiClient.post(`/userbe/createbe`, requestData);
      console.log('Response:', response.data);

     // Update submission status
     setSubmissionStatus('success');

      // Clear form fields
    setSelectedOption('');
    // Reset other form fields to empty strings
    event.target.reset();

    // Reset submission status after 3 seconds
    setTimeout(() => {
      setSubmissionStatus(null);
    }, 3000);

      // Optionally, you can handle success response here
    } catch (error) {
      console.error('Error creating business enquiry:', error);
      // Optionally, you can handle error response here
    }
  };
  
  console.log('Selected option outside',selectedOption)

  return (
    <>
    <div className='enq-desktop mb-5'>
    <div className='jumbotron' style={{ paddingTop: '120px' }}>
        <h2 className='text-center fw-bold'>REQUEST FOR A CUSTOMISED QUOTE</h2>
    </div>
    <div >
      <h3 className='text-center fw-bold' >COMPLETE THE BELOW FORM</h3>
    </div><br/><br/>
    <div className='row' >
      <div className='col-1'></div>
      <div className='col-5'>
        <img src={cus} className='img-fluid'  alt='Benquiry'/>
      </div>
      
      <div className='col-5 backform text-white'  style={{borderRadius:'10px'}}><br/>
      
        <form method='post' onSubmit={handleSubmit}  className='form-group'>
          <div className='row'>
            <div className='col-6'>
            <label htmlFor='fName'>First Name</label>
            <input type='text' id='fName' name='fName' className='form-control' required />
            </div>
            <div className='col-6'>
            <label htmlFor='lName'>Last Name*</label>
            <input type='text' id='lName' name='lName' className='form-control' required />
            </div>
            
          </div>
          <br/>
          <div className='row'>
            <div>
            <label htmlFor='bEmail'>Business Email*</label>
            <input type='email' id='bEmail' name='bEmail' className='form-control' required />
            </div>
          </div>
           <br/>
          <div className='row'>
           <div className='col-6'>
           <label htmlFor='selectedService'>Select Service*</label><br/>
              <select  onChange={handleChange} value={selectedOption} id='selectedService' className='form-control' required >
              <option value="">Please select</option>
              {serviceOptions.map((option, index) => (
                    <option key={index} value={option.serId}>{option.serviceName} - {option.subServiceName}</option>
                  ))}
              </select>
           </div>
           <div className='col-6'>
           <label htmlFor='contactNumber'>Contact Number*</label>
            <input type='text' id='contactNumber' name='contactNumber' className='form-control' required/>
           </div>
          </div>
          <br/>
          <div className='row'>
            <div className=''>
            <label htmlFor='address'>Address*</label>
            <input type='text' id='address' name='address' className='form-control' required/>
            </div>
          </div>
          <div className='row'>
            <div className=''>
            <label htmlFor='message'>Message*</label>
            <input type='text' id='message' name='message' className='form-control' required/>
            </div>
            </div>
            <br/>
            <div className='row justify-content-center'>
            <div className='col-6 offset-3'>
            
            <button type='submit' className='btn btn-primary text-white'>Submit</button>
            </div>
            </div>
             {/* Conditional rendering for success message */}
       {submissionStatus === 'success' && (
            <Alert variant='success' dismissible>
              Form submitted successfully!
            </Alert>
          )}
            
          
        </form>
      </div>
      <div className='col-1'></div>
    
    </div>
      
    </div>
    <div className='enq-mobile'>
      
<div
    className="d-flex justify-content-center align-items-center min-vh-100 "
    style={{
      background: "linear-gradient(120deg, #008080 0%, #FF00FF 100%)",
      position: "relative",
      overflow: "hidden",
      paddingTop: "120px"
    }}
  >
    {/* Animated Gradient Circles */}
    <div
      style={{
        position: "absolute",
        width: 400,
        height: 400,
        borderRadius: "50%",
        background: "radial-gradient(circle, #fbc2eb 0%, #a6c1ee 100%)",
        top: -100,
        left: -100,
        opacity: 0.5,
        filter: "blur(60px)",
        animation: "float 8s ease-in-out infinite alternate",
        zIndex: 1,
      }}
    />
    <div
      style={{
        position: "absolute",
        width: 300,
        height: 300,
        borderRadius: "50%",
        background: "radial-gradient(circle, #fad0c4 0%, #ffd1ff 100%)",
        bottom: -80,
        right: -80,
        opacity: 0.5,
        filter: "blur(60px)",
        animation: "float2 10s ease-in-out infinite alternate",
        zIndex: 1,
      }}
    />
    {/* Glassmorphism Card */}
    <form
      method='post' onSubmit={handleSubmit}
      className="p-5 rounded-4 shadow-lg "
      style={{
        background: "rgba(255,255,255,0.25)",
        backdropFilter: "blur(16px)",
        border: "1px solid rgba(255,255,255,0.18)",
        minWidth: 350,
        zIndex: 2,
      }}
    >
      <h2 className="mb-4 text-center fw-bold" style={{ color: "black" }}>
        REQUEST FOR A CUSTOMISED QUOTE
      </h2>
      <div className="mb-3">
         <label className='fw-semibold form-label' htmlFor='fName'>First Name <span style={{color: '#8B0000'}}>*</span></label>
            <input type='text' id='fName' name='fName' className='form-control form-control-lg' required />
      </div>
      <div className="mb-3">
        <label className='fw-semibold form-label'  htmlFor='lName'>Last Name <span style={{color: '#8B0000'}}>*</span></label>
            <input type='text' id='lName' name='lName' className='form-control' required />
      </div>
      <div className="mb-3">
         <label className='fw-semibold form-label' htmlFor='bEmail'>Business Email <span style={{color: '#8B0000'}}>*</span></label>
            <input type='email' id='bEmail' name='bEmail' className='form-control' required />
      </div>
      <div className="mb-3">
        <label className='fw-semibold form-label' htmlFor='selectedService'>Select Service <span style={{color: '#8B0000'}}>*</span></label><br/>
              <select  onChange={handleChange} value={selectedOption} id='selectedService' className='form-control' required >
              <option value="">Please select</option>
              {serviceOptions.map((option, index) => (
                    <option key={index} value={option.serId}>{option.serviceName} - {option.subServiceName}</option>
                  ))}
              </select>
      </div>
      <div className="mb-3">
         <label className='fw-semibold form-label' htmlFor='contactNumber'>Contact Number <span style={{color: '#8B0000'}}>*</span></label>
            <input type='text' id='contactNumber' name='contactNumber' className='form-control' required/>
      </div>
      <div className="mb-3">
        <label className='fw-semibold form-label' htmlFor='address'>Address <span style={{color: '#8B0000'}}>*</span></label>
            <textarea id='address' name='address' className='form-control' rows={4} required/>
      </div>
      <div className="mb-3">
        <label className='fw-semibold form-label' htmlFor='message'>Message <span style={{color: '#8B0000'}}>*</span></label>
            <input type='text' id='message' name='message' className='form-control' required/>
      </div>
      <div className="mb-3">
        
      
      <button
        type="submit"
        className="btn btn-gradient w-100 py-2 fw-bold"
        style={{
          background: "linear-gradient(90deg, #a18cd1 0%, #3aa58cff 100%)",
          border: "none",
          color: "#fff",
          fontSize: "1.1rem",
          boxShadow: "0 4px 24px rgba(161,140,209,0.2)",
        }}
      >
        Submit
      </button>
      </div>

      <div className='p-2'>
      {/* Conditional rendering for success message */}
       {submissionStatus === 'success' && (
            <Alert variant='success' dismissible>
              Form submitted successfully!
            </Alert>
          )}
    </div>
    </form>
    
    {/* Keyframes for floating animation */}
    <style>
      {`
        @keyframes float {
          0% { transform: translateY(0px);}
          100% { transform: translateY(40px);}
        }
        @keyframes float2 {
          0% { transform: translateY(0px);}
          100% { transform: translateY(-30px);}
        }
      `}
    </style>
  </div>
    </div>
    </>
    
  )
}
